import { Box, Button, Typography } from "@material-ui/core";
import { DuplicateGroupCard } from "./duplicate-group-card";
import { DuplicateGroup } from "./types";

interface NonDuplicateGroupsTabProps {
  groups: DuplicateGroup[];
  hasSearch?: boolean;
  onClearSearch?: () => void;
  loading: boolean;

  expandedGroups: Record<string, boolean>;

  onToggleGroup: (groupId: string) => void;

  onMarkDuplicate: (group: DuplicateGroup) => void;
  processingGroupId?: string | null;
}

export const NonDuplicateGroupsTab: React.FC<
  NonDuplicateGroupsTabProps
> = ({
  groups,
  hasSearch = false,
  onClearSearch,
  loading,
  expandedGroups,
  onToggleGroup,
  onMarkDuplicate,
  processingGroupId,
}) => {
  if (loading) {
    return (
      <Box
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography color="textSecondary">
          Loading non-duplicate groups...
        </Typography>
      </Box>
    );
  }

  if (!groups.length) {
    return (
      <Box
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 40,
        }}
      >
        <Typography
          style={{
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 5,
          }}
        >
          {hasSearch ? 'No matching groups' : 'No Non-Duplicate Groups'}
        </Typography>

        <Typography
          style={{
            fontSize: 11,
            color: '#64748B',
          }}
        >
          {hasSearch
            ? 'No non-duplicate groups match this title or IMDb id.'
            : 'Groups marked as not duplicate will appear here.'}
        </Typography>

        {hasSearch && onClearSearch && (
          <Button
            size="small"
            onClick={onClearSearch}
            style={{
              marginTop: 10,
              color: '#2563EB',
              textTransform: 'none',
              fontSize: 11,
            }}
          >
            Clear search
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box
      style={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: '4px 20px 20px',
      }}
    >
      {groups.map(group => (
        <DuplicateGroupCard
          key={group.groupKey || group.id}
          group={group}
          expanded={expandedGroups[group.id] === true}
          onToggle={() => onToggleGroup(group.id)}
          mode="nonDuplicate"
          onMarkDuplicate={onMarkDuplicate}
          actionLoading={processingGroupId === group.id}
        />
      ))}
    </Box>
  );
};
